import dynamic from 'next/dynamic';
import { NextSeo, CorporateContactJsonLd } from 'next-seo';
import Layout from '@components/common/Layout';
import { COMPANY_EMAIL, COMPANY_PHONE_NUMBER } from '@lib/constants';
import ContactForm from '@components/contact-us/ContactForm';

const ServiceArea = dynamic(() => import('@components/contact-us/ServiceArea'));

export default function ContactUs() {
  return (
    <>
      <NextSeo
        title="Contact Us for All Your Residential and Commercial Electrical Needs in the Phoenix Metropolitan area"
        description={`Call us at ${COMPANY_PHONE_NUMBER} or email us at ${COMPANY_EMAIL} or use our online contact form.`}
        canonical="https://www.hlbelectric.com/contact-us"
        openGraph={{
          title:
            'Contact Us for All Your Residential and Commercial Electrical Needs in the Phoenix Metropolitan area | HLB Electric',
          description: `Call us at ${COMPANY_PHONE_NUMBER} or email us at ${COMPANY_EMAIL} or use our online contact form.`,
          url: 'https://www.hlbelectric.com/contact-us',
        }}
      />
      <CorporateContactJsonLd
        url="https://www.hlbelectric.com/contact-us"
        logo="https://www.hlbelectric.com/images/original-hlb-logo.png"
        contactPoint={[
          {
            telephone: `${COMPANY_PHONE_NUMBER}`,
            contactType: 'customer service',
            availableLanguage: 'English',
          },
        ]}
      />
      <div className="bg-stone-50">
        <div className="py-24 lg:py-32">
          <div className="relative max-w-7xl mx-auto pl-4 pr-8 sm:px-6 lg:px-8">
            <h1 className="text-4xl font-extrabold tracking-tight text-stone-900 sm:text-5xl lg:text-6xl">
              Get in touch
            </h1>
            <p className="mt-6 text-xl text-stone-500 max-w-3xl">
              Want to get in touch? We&apos;d love to hear from you.
            </p>
          </div>
        </div>
      </div>
      <ContactForm />
      <ServiceArea />
    </>
  );
}

ContactUs.Layout = Layout;
